var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStairsIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7923_47)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 254,
    height: 254,
    rx: 15,
    fill: "#EEF0FE",
    stroke: "#4A4A68",
    strokeWidth: 2,
    strokeDasharray: "8 8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.623,
    cy: 59.2373,
    r: 14.4209,
    fill: "#223BF4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.0815,
    cy: 54.3392,
    r: 1.73124,
    transform: "rotate(22.0029 89.0815 54.3392)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.144,
    cy: 49.8319,
    r: 1.73124,
    transform: "rotate(22.0029 101.144 49.8319)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9648 56.2752C98.7814 57.0741 100.343 56.2752 100.814 54.8955",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1776 77.8064C72.1564 74.0209 79.8484 58.8016 79.8484 54.8406C86.0274 67.3129 86.9163 79.4612 76.9746 89.3244C73.4126 92.8584 58.1765 89.843 54.4517 86.5285C48.0431 80.8257 51.4229 81.1698 61.1776 77.8064Z",
    fill: "#223BF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.047 47.4826C115.229 51.6682 104.818 50.1251 102.822 48.7144C106.908 56.2707 112.714 61.0452 121.226 59.5469C124.276 59.01 128.183 50.2566 127.838 47.1987C127.246 41.9376 126.216 43.7637 121.047 47.4826Z",
    fill: "#223BF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.832 100.06C254.339 117.99 212.312 109.082 212.312 168.522C207.225 104.507 161.065 128.091 161.065 107.12C161.065 77.9427 195.901 103.232 197.646 97.1039C199.444 90.7861 156.929 85.4544 164.278 69.2173C173.3 49.2852 201.472 83.7722 201.472 75.9313C201.472 54.4065 161.065 61.8739 164.278 46.3478C167.742 29.6098 182.201 41.7441 201.472 57.1127C191.371 43.1753 196.903 6.15902 212.312 10.0503C238.067 16.5545 200.836 42.3768 210.227 58.9368C215.524 68.2776 224.494 26.4158 238.552 38.7948C255.154 53.4148 210.407 59.8955 212.312 76.9803C212.77 81.0917 232.898 53.7714 241.279 67.0504C250.86 82.2307 208.67 97.9271 212.312 105.935C220.075 123.003 239.81 70.6856 248.832 100.06Z",
    fill: "#1CDBCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2207 218.217V245.412H238.399V166.495H174.649V193.411H133.566V218.217H90.2207Z",
    fill: "#909DF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.509 63.2855C100.69 59.7906 79.2576 86.0564 68.5545 101.73C57.8515 117.404 47.4204 146.419 26.2172 133.713C26.2172 133.713 24.0159 132.772 23.3036 134.553C22.5914 136.335 26.2172 138.812 26.2172 138.812C26.2172 138.812 23.7088 137.684 23.3036 139.545C22.8984 141.407 27.2693 143.749 27.2693 143.749C27.2693 143.749 23.9748 142.243 23.3036 144.189C22.6324 146.136 27.7549 148.928 27.7549 148.928C27.7549 148.928 24.7853 147.496 23.9018 149.762C23.0184 152.028 29.0497 155.483 29.0497 155.483C46.3323 161.743 74.7116 139.911 80.4099 124.293C82.3222 128.596 82.8002 138.917 78.7367 149.762C74.6732 160.608 65.7512 165.785 55.1484 182.096C44.5456 198.406 46.7816 239.13 42.7318 239.13C39.492 239.13 36.3948 243.441 37.2772 246.48H59.5376C61.7551 246.48 63.8815 245.452 64.9779 243.524C72.0991 231.006 72.2021 212.011 85.9618 199.899C100.855 186.788 123.755 174.627 143.89 160.608C163.634 146.861 197.532 134.03 200.418 165.645C200.515 166.707 201.391 167.575 202.457 167.575H229.738C232.496 163.082 222.517 162.823 222.78 160.608C223.945 150.763 221.896 136.014 212.639 120.818C201.3 102.203 165.286 106.252 150.1 120.818C150.1 109.622 148.24 101.73 143.89 90.4051C171.179 87.9255 179.997 55.4955 175.587 34.2889C175.587 34.2889 174.74 30.5281 172.794 29.4055C170.849 28.2829 171.179 31.7262 171.179 31.7262C171.179 31.7262 170.61 28.52 169.144 28.1535C167.678 27.7871 167.678 30.9628 167.678 30.9628C167.678 30.9628 166.936 27.7742 165.046 27.5123C163.155 27.2504 163.43 29.9386 163.43 29.9386C163.43 29.9386 162.69 27.0404 161.043 26.7821C159.395 26.5238 159.334 28.3312 159.78 31.9399C160.226 35.5486 162.328 66.7805 131.509 63.2855Z",
    fill: "#223BF4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7923_47"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStairsIllustration);
export default __webpack_public_path__ + "static/media/stairs-illustration.6297f2126b19c5431522358d2c27e484.svg";
export { ForwardRef as ReactComponent };